import { render, staticRenderFns } from "./feeDetail.vue?vue&type=template&id=2ebbc19c&"
import script from "./feeDetail.vue?vue&type=script&lang=js&"
export * from "./feeDetail.vue?vue&type=script&lang=js&"
import style0 from "./feeDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports